import { atom } from "recoil";
import { SelectedDevice } from "../../DeviceOverview";

export const selectedDevicesForTagsAtom = atom<SelectedDevice[] | undefined>({
  key: "selectedDevicesForTagsAtom",
  default: undefined,
});
